<template>
    <TotemSelect
        :options="instructorsOptions"
        :placeholder="$t('CourseListFilter.instructor')"
        @input="selectInstructor"
        class="filter-select"
        ref="selectInstructor"
        :value="selectedInstructor"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'InstructorFilter',
        props: {
            courseList: Array
        },
        computed: {
            ...mapGetters({
                selectedInstructor: 'CourseFilter/getSelectedInstructor'
            }),
            instructorsOptions () {
                const instructors = []

                this.courseList.forEach(item => {
                    const instructor = item.instructor

                    if (instructor && !instructors.find(_instructor => +_instructor.instructor === +instructor.id)) {
                        const label = instructor.name
                        const instructorId = instructor.id
                        instructors.push({ label, instructor: instructorId })
                    }

                    if (item.instructors) {
                        item.instructors.forEach((instructor) => {
                            if (instructor && !instructors.find(_instructor => +_instructor.instructor === +instructor.id)) {
                                const label = instructor.name
                                const instructorId = instructor.id
                                instructors.push({ label, instructor: instructorId })
                            }
                        })
                    }
                })

                instructors.sort((a, b) => {
                    if (!a.label) {
                        return 1
                    }

                    if (!b.label) {
                        return -1
                    }

                    return a.label.localeCompare(b.label)
                })

                return instructors
            }
        },
        methods: {
            filterByInstructor (data) {
                if (this.selectedInstructor === null) {
                    return data
                }

                return data.filter(item => {
                    if (item.instructors) {
                        return item.instructors.find(instructor => instructor.id === this.selectedInstructor.instructor)
                    }

                    return item.instructor && item.instructor.id === this.selectedInstructor.instructor
                })
            },
            selectInstructor (option) {
                this.$store.dispatch('CourseFilter/selectInstructor', option)
            },
            clear () {
                this.$refs.selectInstructor.clear()
            }
        }
    }
</script>
